import { render, staticRenderFns } from "./loading-bar.vue?vue&type=template&id=6c3e1124&scoped=true&"
import script from "./loading-bar.vue?vue&type=script&lang=ts&"
export * from "./loading-bar.vue?vue&type=script&lang=ts&"
import style0 from "./loading-bar.vue?vue&type=style&index=0&id=6c3e1124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3e1124",
  null
  
)

export default component.exports